/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import {
  PositionDTO,
  WizardDTO,
  SurveyDTO,
  FormDTO,
  ChecklistDTO
} from '@api/models';

export interface DTOMappers {
  generic<T>(res: any): T;
  position(res: any): PositionDTO;
  wizard(res: any): WizardDTO;
  surveys(res: any): SurveyDTO[];
  forms(res: any): FormDTO[];
  checklist(res: any): ChecklistDTO;
}
